// import React from 'react'

import Hero from './components/features/Hero';
import Footer from './components/Footer';
import CoreFeatures from './components/home/CoreFeatures';
import KeyFeaturesBenefits from './components/home/KeyFeaturesBenefits';
import PricingCards from './components/home/Pricingcard';
import PromoBanner from './components/home/PromoBanner';

const Features = () => {
  return (
    <div>
      <Hero />
      <CoreFeatures />
      <PromoBanner />
      <KeyFeaturesBenefits />
      <PricingCards />
      <Footer />
    </div>
  );
};

export default Features;
